export default function Mission() {
  return (
    <section id="mission" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-teal-100 mb-6">
            <i className="ri-heart-pulse-line text-3xl text-teal-600"></i>
          </div>
          
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Our Mission
          </h2>
          
          <div className="w-24 h-1 bg-teal-500 mx-auto mb-8"></div>
          
          <p className="text-xl text-gray-700 leading-relaxed mb-8">
            At Gentle Roots Home Care, our mission is to provide compassionate, personalized non-medical home care that empowers individuals to live independently and comfortably in the place they love most — their own home.
          </p>
          
          <p className="text-lg text-gray-600 leading-relaxed mb-8">
            We believe that every person deserves to age with dignity, respect, and the highest quality of care. Our dedicated caregivers are committed to building meaningful relationships with clients and their families, offering support that goes beyond basic assistance to truly enhance quality of life.
          </p>
          
          <div className="grid md:grid-cols-3 gap-8 mt-12">
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-teal-50 mb-4">
                <i className="ri-heart-3-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Compassion</h3>
              <p className="text-gray-600 text-sm">Treating every client with kindness, empathy, and respect</p>
            </div>
            
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-teal-50 mb-4">
                <i className="ri-user-star-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Personalized Care</h3>
              <p className="text-gray-600 text-sm">Tailoring our services to meet each individual's unique needs</p>
            </div>
            
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-teal-50 mb-4">
                <i className="ri-shield-check-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Trust</h3>
              <p className="text-gray-600 text-sm">Building lasting relationships through reliability and integrity</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}